/**
 * @file Purchase PPD Print Package Modal.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import withModal from '../global/modal/withModal';
import { PURCHASE_PPD_PURCHASE_PACKAGE } from '../../constants/modals';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Button from '../global/Button';
import { DIGITAL_DOWNLOADS_MODE } from '../../constants/print-packages';
import PurchasePpdPrintPackageItem from './PurchasePpdPrintPackageItem';
import { getEligibleAlbumPrintPackagesForPhoto } from '../../util/ppd-purchase';
import { sortArrayByKey } from '../../util/sorting';

class PurchasePpdPrintPackageModal extends Component {
  static propTypes = {
    actionProps: PropTypes.shape({
      comparedFaces: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
      photo: PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
            url: PropTypes.string,
          }),
        ),
      }),
      removeDownloadItem: PropTypes.bool,
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
      album_print_packages: PropTypes.shape({
        total: PropTypes.number,
        record: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            print_package: PropTypes.shape({
              id: PropTypes.string,
              items: PropTypes.shape({
                records: PropTypes.arrayOf(
                  PropTypes.shape({
                    id: PropTypes.string.isRequired,
                    quantity: PropTypes.number,
                    type: PropTypes.shape({
                      name: PropTypes.string,
                      min_price: PropTypes.shape({
                        value: PropTypes.number,
                      }),
                    }),
                  }),
                ),
              }),
              digital_downloads_mode: PropTypes.oneOf(
                Object.values(DIGITAL_DOWNLOADS_MODE),
              ),
              digital_downloads_upsell_price: PropTypes.shape({
                value: PropTypes.number,
              }),
            }),
          }),
        ),
      }),
    }),
    cart: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(Object.keys(PPD_CART_ITEM_TYPES)),
        photo: PropTypes.shape({
          id: PropTypes.string,
        }),
        printSize: PropTypes.shape({
          id: PropTypes.string,
        }),
        printPackage: PropTypes.shape({
          id: PropTypes.string,
        }),
        quantity: PropTypes.number,
      }),
    ),
    toggleCartItem: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  render() {
    const {
      album,
      actionProps: { photo, removeDownloadItem },
      cart,
      toggleCartItem,
      onRequestClose,
    } = this.props;

    const albumPrintPackages = get(album, 'album_print_packages.records', []);
    const eligibleAlbumPrintPackages = sortArrayByKey(
      getEligibleAlbumPrintPackagesForPhoto(albumPrintPackages, photo),
      'print_package.price.value',
    );

    return (
      <div>
        <h3 className="text-center">Select a print package</h3>
        <p className="text-center">
          Select one or more print packages for purchase
        </p>
        <div className="container">
          <div className="row">
            {eligibleAlbumPrintPackages.map(albumPrintPackage => (
              <PurchasePpdPrintPackageItem
                key={albumPrintPackage.id}
                cart={cart}
                photo={photo}
                albumPrintPackage={albumPrintPackage}
                toggleCartItem={toggleCartItem}
                removeDownloadItem={removeDownloadItem}
              />
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <Button onClick={onRequestClose} btnBlock className="text-center">
            Continue Shopping
          </Button>
        </div>
      </div>
    );
  }
}

export { PurchasePpdPrintPackageModal as PurchasePpdPrintPackageModalComp };

export default withModal(PurchasePpdPrintPackageModal, {
  name: PURCHASE_PPD_PURCHASE_PACKAGE,
  size: 'sm',
  type: 'full',
  hideHeader: true,
});
